import { render, staticRenderFns } from "./checkout-calculation.vue?vue&type=template&id=632d926e&scoped=true"
import script from "./checkout-calculation.vue?vue&type=script&lang=js"
export * from "./checkout-calculation.vue?vue&type=script&lang=js"
import style0 from "./checkout-calculation.vue?vue&type=style&index=0&id=632d926e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632d926e",
  null
  
)

export default component.exports